// extracted by mini-css-extract-plugin
module.exports = {"ui1":"var(--ui1)","textInverse":"var(--textInverse)","spinner":"Spinner_spinner__hyJz1"};